import { Toolbar } from '@mui/material'
import React, { useState } from 'react'
import { DashboardHead } from '../../Dashboard/DashboardPage'
import { DataTable, SelectField, ToolbarComponent } from '../../../../../components'
import { feesHeadCells } from '../../../../../shared/data/headCells'
import { FeeInfo, StudentFee } from './components/FeeInfo'
import { useDispatch, useSelector } from 'react-redux'
import {
  setOpenExportModal,
  setOpenExportModalFee,
  setOpenFeeConfirm,
} from '../../../../../redux/globalSlice'
import { FilterSection, SelectPopUp } from '../../../../../components/Toolbar/Toolbar'
import { urls } from '../../../../../shared/config'
import { useGlobal } from '../../../../../shared'
import { InfoField } from '../School/PopOver/SchoolInfo'
import DashboardCard from '../../Dashboard/component/Card'
import IndividualStudentFees from './IndividualFees/IndividualStident'
import { highestInt, yearOptions } from '../../../../../shared/utils/constants'
import { ImportIcon } from '../../../../../assets/icons'
import ExportFeeReport from './components/ExportFeeReport/ExportTransportReport'
import NewSelectedField from '../../../../../common/NewSelectedField/NewSelectedField'
import { downloadCSV } from '../../../../../shared/config/downloadCSV'
import { toast } from 'react-toastify'

const feeStatusOptions = [
  { label: 'UnPaid', value: 'UnPaid' },
  { label: 'Paid', value: 'Paid' },
  { label: 'Partial Paid', value: 'Partial Paid' },
]
const Fees = () => {
  const monthOptions = [
    { label: 'January', value: 'January' },
    { label: 'February', value: 'February' },
    { label: 'March', value: 'March' },
    { label: 'April', value: 'April' },
    { label: 'May', value: 'May' },
    { label: 'June', value: 'June' },
    { label: 'July', value: 'July' },
    { label: 'August', value: 'August' },
    { label: 'September', value: 'September' },
    { label: 'October', value: 'October' },
    { label: 'November', value: 'November' },
    { label: 'December', value: 'December' },
  ]
  const currentMonthName = monthOptions[new Date().getMonth()].value
  const currentYear = new Date().getFullYear()
  const [selectedYear, setSelectedYear] = useState(currentYear)
  const [selectedMonth, setSelectedMonth] = useState(currentMonthName)
  const userSchoolId = localStorage.getItem('userSchoolId')
  const storedAttributes = localStorage.getItem('userAttributes')
  const attributes = JSON.parse(storedAttributes)
  const customRole = attributes?.employee_type
  const [selectedType, setSelectedType] = useState('Monthly')

  const dispatch = useDispatch()
  const [detail, setDetail] = useState(false)
  const [selectedStatus, setSelectedStatus] = useState('')
  const [pageFee, setPageFee] = useState(1)
  const [search, setSearch] = useState('')
  const rowsPerPage = useSelector((state) => state.global.rowsPerPage)
  const feeInfo = useSelector((state) => state.global.openFeeConfirm)
  const openExport = useSelector((state) => state.global.openExportModalFee)
  const [schoolName, setSchoolName] = React.useState('')
  const [individual, setIndividual] = useState(false)
  const [selectedGrade, setSelectedGrade] = useState('')
  const [selectedClass, setSelectedClass] = useState('')
  const school_fee_method = localStorage.getItem('school_fee_method')

  const api = `${urls.FEES_GET}school_id=${customRole == 'Admin' ? userSchoolId : schoolName}&page=${pageFee}&limit=${rowsPerPage}&month=${selectedMonth}&grade_id=${selectedGrade}&section_id=${selectedClass}&keyword=${search}&school_fee-method=${school_fee_method}`

  const statusApi = `${urls.FEE_STATUS}${selectedStatus}&page=${pageFee}&limit=${rowsPerPage}&school_id=${customRole == 'Admin' ? userSchoolId : schoolName}&month=${selectedMonth}&grade_id=${selectedGrade}&section_id=${selectedClass}`
  const { data: schoolList } = useGlobal({
    userUrl: `${urls.SCHOOL_LIST}?page=1&limit=${highestInt}`,
  })
  // console.log('------selected dtsast', selectedClass)

  const { data: Data, refetch } = useGlobal({ userUrl: api })

  // console.log('-----data',Data);

  // const feeData = Data && Data?.getFeePayload
  const { data: feestatus } = useGlobal({ userUrl: statusApi })
  // const statusFee = feestatus && feestatus?.searchSchoolPayload
  // const { data: searchFee } = useGlobal({
  //   userUrl: `${urls.FEE_SEARCH}${search}&school_id=${customRole == 'Admin' ? userSchoolId : schoolName}&month=${selectedMonth}&page=${pageFee}&limit=${rowsPerPage}&grade_id=${selectedGrade}&section_id=${selectedClass}`,
  // })
  const { data: grades } = useGlobal({
    userUrl: `${urls.CLASS_GRADE}${customRole == 'Admin' ? userSchoolId : schoolName}&page=1&limit=10000`,
  })
  const { data: analyticsData } = useGlobal({
    userUrl: `${urls.FEE_ANALYTICS}${customRole == 'Admin' ? userSchoolId : schoolName}`,
  })

  // console.log('--==analyticsData',analyticsData)?;

  const row = selectedStatus !== '' ? feestatus : Data

  const pagecount = selectedStatus ? feestatus?.countStudent : Data?.countStudent
  const userSchoolName = schoolList?.find((school) => school.school_id == userSchoolId)?.school_name

  const cardItems = [
    { title: 'Total Fees', content: analyticsData?.totalFee?.toFixed(2), stats: '22.10' },
    { title: 'Paid Fees', content: analyticsData?.PaidFee?.toFixed(2), stats: '32.11' },
    { title: 'Unpaid Fees', content: analyticsData?.RemainingFee?.toFixed(2), stats: '62.10' },
  ]
  if (individual && school_fee_method!=='Annually') {
    return <IndividualStudentFees setIndividual={setIndividual} userSchoolId={userSchoolId} />
  }
  // console.log('--latestyears',latest_years);
  const handleExport = () => {
    // Get the current data from the table
    const currentData = row || []

    if (currentData && currentData.length > 0) {
      // Generate filename with current filters
      let filename = 'Fees'

      if (schoolName) {
        const school = schoolList?.find((s) => s.school_id === schoolName)
        if (school) {
          filename += `_${school.school_name.replace(/\s+/g, '_')}`
        }
      } else if (customRole === 'Admin' && userSchoolName) {
        filename += `_${userSchoolName.replace(/\s+/g, '_')}`
      }

      if (selectedGrade) {
        const grade = grades?.find((g) => g.grade_id === selectedGrade)
        filename += `_G${grade?.grade || selectedGrade}`
      }

      if (selectedClass) {
        filename += `_C${selectedClass}`
      }

      if (selectedStatus) {
        filename += `_${selectedStatus.replace(/\s+/g, '')}`
      }

      filename += `_${selectedMonth}`

      // Add current date
      const date = new Date().toISOString().split('T')[0]
      filename += `_${date}`

      // Get the data array (handle different possible structures)
      const exportData = Array.isArray(currentData)
        ? currentData
        : currentData?.data || currentData?.getFeePayload || []

      if (exportData.length > 0) {
        downloadCSV(exportData, filename)
        // toast.success(`${exportData.length} fee records exported`);
      } else {
        toast.error('No data to export')
      }
    } else {
      toast.error('No data to export')
    }
  }

  return (
    <div>
      <Toolbar />
      <DashboardHead title={`Fees: ${school_fee_method}`} fees={true} subtitle={'Finance / Fees'} />
      <div className="school-toolbar">
        <div style={{ width: '40%' }}>
          {customRole != 'Admin' ? (
            <SelectField
              placeholder={'Select School'}
              options={(schoolList || [])?.map((prod) => ({
                value: prod.school_id,
                label: prod.school_name,
              }))}
              name="schoolName"
              value={schoolName}
              onChange={(selectedOption) => {
                setSchoolName(selectedOption)
                setPageFee(1)
              }}
            />
          ) : (
            <InfoField value={userSchoolName} />
          )}
        </div>
      </div>
      {/* <div className={classes.boxes}>
        {feesData.map((value, index ) => {
          return (
            <div key={index} className={classes.box}>
              <div className={classes.lhs}>

              </div>
              <div className={classes.iconframe}>
                <img src={calculator} alt="FSM"  />
              </div>
            </div>
          )
        })}
      </div> */}

      <div className="dashboard-cards">
        {cardItems.map((card, index) => (
          <DashboardCard key={index} title={card.title} content={card.content} stats={card.stats} />
        ))}
      </div>
      {/* <SelectField
        placeholder="Select Month"
        options={monthOptions}
        value={selectedMonth}
        name="month"
        onChange={(val) => setSelectedMonth(val)}
      /> */}
      <ToolbarComponent
        search={search}
        setSearchItem={setSearch}
        fees
        btnText={'Collect Fee'}
        handleOpen={() => dispatch(setOpenFeeConfirm(true))}
        setPage={setPageFee}
      >
        <SelectPopUp
          selectedStatus={selectedStatus}
          setSelectedStatus={setSelectedStatus}
          selectOptions={feeStatusOptions}
        />
        <NewSelectedField
          fee={true}
          grades={grades}
          selectedGrade={selectedGrade}
          selectedMonth={selectedMonth}
          setSelectedClass={setSelectedClass}
          setSelectedGrade={setSelectedGrade}
          selectedClass={selectedClass}
        />
        {/* <SelectField
          placeholder={''}
          options={(selectedType === 'Monthly' ? monthOptions : yearOptions || [])?.map((prod) => ({
            value: prod?.value,
            label: prod.label,
          }))}
          name="selectedMonth"
          value={selectedType === 'Monthly' ? selectedMonth : selectedYear}
          onChange={(selectedOption) => {
            selectedType === 'Monthly'
              ? setSelectedMonth(selectedOption)
              : setSelectedYear(selectedOption)
          }}
          subLabel={selectedType === 'Monthly' ? 'Month : ' : 'Year :'}
          width={'fit-content'}
          filter
          fees
          containerWidth={'fit-content'}
        /> */}
        {/* <SelectField
          placeholder={''}
          width={'fit-content'}
          options={(['Monthly', 'Yearly'] || [])?.map((prod) => ({
            value: prod,
            label: prod,
          }))}
          name="selectedType"
          value={selectedType}
          onChange={(selectedOption) => {
            setSelectedType(selectedOption)
            setSelectedMonth(selectedMonth)
            setSelectedYear(selectedYear)
          }}
          filter={true}
          fees
          containerWidth={'fit-content'}
        /> */}
        <FilterSection icon={ImportIcon} onClick={handleExport} title={'Export'} />

        {/* <FilterSection icon={FilterIcon} title={'Filter'} /> */}
      </ToolbarComponent>
      <DataTable
        rowData={row}
        headCells={feesHeadCells}
        fees
        setPageFee={setPageFee}
        pageFee={pageFee}
        handleDetailOpen={() => setDetail(true)}
        pageCount={pagecount}
        handleIndividualOpen={() => {
          setIndividual(true)
        }}
      />
      {detail && (
        <FeeInfo month={selectedMonth} open={detail} handleClose={() => setDetail(false)} />
      )}
      {feeInfo && (
        <StudentFee
          month={selectedMonth}
          open={feeInfo}
          userSchoolId={userSchoolId}
          handleClose={() => dispatch(setOpenFeeConfirm(false))}
          refetch={refetch}
        />
      )}
      {/* {openExport && (
        <ExportFeeReport
          role={customRole}
          schoolList={schoolList}
          userSchoolId={userSchoolId}
          open={openExport}
        />
      )} */}
    </div>
  )
}

export default Fees
